import axios from "axios";
export const getUserDetails = async () => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  return await axios.get(`https://${host}/${context}/outlook/userInfo.action`, {
    headers: {
      "content-type": "application/json",
      "originated": "teams",
      "post-type": "ajax",
      "outlookauth": appToken,
    },
  });
};
